import {  AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { 
  faBook,
  faFilter,
  faSearch,
  faSync,
  faTable,
  faFileExcel,
  faDownload,
  faArrowsUpDown,
  faColumns
} from '@fortawesome/free-solid-svg-icons';
import { TutorialItems } from './inicio.interface';
import { UserService } from 'src/app/shared/services/users/users.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { IApiUserAuthenticated } from 'src/app/shared/interfaces/IApiUserAuthenticated';
import { InicioService } from './inicio.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
 
@Component({
  selector: 'app-tutorial-xenobioticos',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent  implements OnInit  {
  @ViewChild('CheckSaltearIntro', { static: false }) CheckSaltearIntro!: ElementRef;
   
  currentUser!: any;
  selectedItem: string = 'interface';
  selectedSubsection: number | null = null;

  // Definición individual de íconos
  faBook = faBook;
  faFilter = faFilter;
  faSearch = faSearch;
  faSync = faSync;
  faTable = faTable;
  faFileExcel = faFileExcel;
  faDownload = faDownload;
  faArrowsUpDown = faArrowsUpDown;
  faColumns = faColumns;

  // Objeto icons para referencias fáciles
  icons = {
    book: this.faBook as IconProp,
    filter: this.faFilter as IconProp,
    search: this.faSearch as IconProp,
    sync: this.faSync as IconProp,
    table: this.faTable as IconProp,
    excel: this.faFileExcel as IconProp,
    download: this.faDownload as IconProp,
    arrows: this.faArrowsUpDown as IconProp,
    columns: this.faColumns as IconProp
  };

  
  tutorialItems: TutorialItems = {
    interface: {
      title: 'Sección Descargas',
      icon: this.faBook as IconProp,
      description: 'Control de descarga y contadores',
      subsections:[],
      details: [
        'Los contadores muestran cantidad de registros seleccionados y cantidad total de registros',
        'Botón de descarga: Descarga todos los documentos seleccionados por tipo (Solo los tipos marcados para cada registro)',
        'Filtros de Tipo de documento (Certificados, Actas, Facturas) a descargar' ,
        'Se pueden descargar hasta 100 archivos por vez.',
        'La tasa de descargas de archivos es de 2 por segundo.'
      ],
      visual: 'interface'
    },
    filtrosEncabezado: {
      title: 'Filtros de Encabezado',
      icon: this.faFilter as IconProp,
      description: 'Sistema de filtrado y ordenamiento por columnas',
      details: [
        'Cada columna permite ordenamiento ascendente/descendente',
        'Filtros específicos por tipo de columna',
        'Búsqueda por texto en columnas de texto',
        'Filtros por rango en fechas'
      ],
      visual: 'filtros',
      subsections: [
        {
          title: 'Ordenamiento',
          icon: this.faArrowsUpDown as IconProp,
          description: 'Opciones de ordenamiento por columna',
          details: [
            'Click para ordenar ascendente',
            'Segundo click para ordenar descendente',
            'Tercer click para quitar ordenamiento',
            'Se mantiene al aplicar filtros'
          ]
        },
        {
          title: 'Filtros',
          icon: this.faFilter as IconProp,
          description: 'Opciones de filtrado por columna',
          details: [
            'Búsqueda por texto parcial o exacto',
            'Filtros por rango de fechas',
            'Filtros por estado en columna Pago',
            'Múltiples filtros simultáneos'
          ]
        }
      ]
    },
    tipoBusqueda: {
      title: 'Tipo de Búsqueda',
      icon: this.faSearch as IconProp,
      description: 'Selector de vista de registros',
      subsections: [
        {
          title: 'Pendientes',
          icon: this.faSync as IconProp,
          description: 'Solo trae aquellos registros que el usuario aun no haya descargado su certificado',
          details: [
            'Vista predeterminada',
            'Mejora el control de pendientes',
            'Solo muestra los NO descargados' 
          ]
        },
        {
          title: 'Todos los informes',
          icon: this.faTable as IconProp,
          description: 'Trae todos los registros sin importar si ya fue descargado',
          details: [
            'Historico completo a partir del 2024',
            'incluye descargados'  
          ]
        }
      ],
      details: [
        'Permite alternar entre registros pendientes y todos',
        'Por defecto muestra solo pendientes de descarga',
        'La opción "Todos" incluye histórico completo'
      ],
      visual: 'busqueda'
    },
    accionesPrincipales: {
      title: 'Acciones Principales',
      icon: this.faSync as IconProp,
      description: 'Botones principales y sus funciones',
      details: [
        'Ubicados en la parte superior derecha',
        'Recarga de datos, conservando filtros',
        'Rapida recuperacion de estructura inicial de grilla'
      ],
      visual: 'acciones',
      subsections: [
        {
          title: 'Botón Datos',
          icon: this.faSync as IconProp,
          description: 'Actualización de información',
          details: [
            'Refresca los datos desde el servidor',
            'Mantiene la información sincronizada',
            'Conserva los filtros aplicados',
            'Mantiene las selecciones actuales' 
          ]
        },
        {
          title: 'Botón Grilla',
          icon: this.faTable as IconProp,
          description: 'Gestión de vista',
          details: [
            'Restaura el orden original de las columnas',
            'Restablece el ancho predeterminado',
            'Recupera columnas ocultas',
            'No afecta a los filtros activos',
            'Útil cuando la vista está muy modificada',
            'Ayuda a recuperar columnas importantes'
          ]
        }
      ]
    },
    herramientasPersonalizacion: {
      title: 'Herramientas de Personalización',
      icon: this.faColumns as IconProp,
      description: 'Opciones para personalizar la vista y exportar datos',
      details: [
        'Permite personalizar la visualización de columnas',
        'Opciones de exportación de datos',
        'Configuración persistente entre sesiones'
      ],
      visual: 'herramientas',
      subsections: [
        {
          title: 'Gestión de Columnas',
          icon: this.faColumns as IconProp,
          description: 'Personalización de la vista',
          details: [
            'Selecciona qué columnas mostrar',
            'Arrastra para reordenar columnas',
            'Ajusta el ancho de cada columna',
            'La configuración se guarda automáticamente',
            'Se mantiene entre sesiones',
            'Personaliza según tus necesidades'
          ]
        },
        {
          title: 'Exportación de Datos',
          icon: this.faFileExcel as IconProp,
          description: 'Exportación a Excel',
          details: [
            'Exporta la vista actual a Excel',
            'Incluye todos los registros filtrados',
            'Mantiene el formato de fechas',
            'Compatible con todas las versiones de Excel',
            'Incluye encabezados de columna',
            'Conserva los datos numéricos'
          ]
        }
      ]
    }
  };
   clientes:any[]=[];
   mostrarClientes:boolean=false;
  constructor(private Serv:InicioService,private authService:AuthService) {
      Serv.getClientes().subscribe((data:any)=>{this.clientes=data});
      this.currentUser  = this.authService.getUser;
    
      if (this.currentUser?.Role!='Admin'){
        this.mostrarClientes=true;
      }

    
       
  }

  ngOnInit(): void {
 
  
  }


  selectItem(key: string): void {
    this.selectedItem = key;
    this.selectedSubsection = null;
  }

  ngAfterViewInit() {
    if (this.CheckSaltearIntro?.nativeElement) {
      this.CheckSaltearIntro.nativeElement.checked = this.currentUser.MostrarAyuda;
  }


  }


  onCheckboxChange(event: Event) {
    if (this.CheckSaltearIntro?.nativeElement instanceof HTMLInputElement) {
        const isChecked = this.CheckSaltearIntro.nativeElement.checked;
        
        this.Serv.setAyudaInicial(isChecked)
            .pipe(
                catchError(error => {
                    // Si el error es 200, significa que es exitoso
                    if (error.status === 200) {
                        return of(error.error);  // Convierte la respuesta en Observable
                    }
                    throw error;  // Re-lanza otros errores
                })
            )
            .subscribe({
                next: (data: any) => {
                    this.currentUser.MostrarAyuda = isChecked;
                    console.log('Actualizado correctamente:', data);
                },
                error: (error) => {
                    if (error.status !== 200) {  // Solo maneja errores reales
                        console.error('Error real:', error);
                        this.CheckSaltearIntro.nativeElement.checked = !isChecked;
                    }
                }
            });
    }
}
 
  getCheckboxValueFromStorage(): boolean {
    const value = localStorage.getItem('SaltearIntroChecked');
    return value ? value === 'true' : false;
  }
  selectSubsection(index: number): void {
    this.selectedSubsection = this.selectedSubsection === index ? null : index;
  }

  trackByFn(index: number): number {
    return index;
  }
}